import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PrescriptionTemplateForm } from "./components/PrescriptionTemplateForm";

export function PrescriptionTemplateCreatePage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-1">
          <h1 className="text-2xl font-bold tracking-tight text-foreground">
            Tạo toa thuốc mẫu
          </h1>
          <p className="text-sm text-muted-foreground">
            Lưu tổ hợp chẩn đoán + danh sách thuốc thường dùng để tái sử dụng khi kê đơn.
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Button asChild variant="outline" size="sm">
            <Link to="/prescriptions/templates">
              <ArrowLeft className="h-4 w-4" />
              Danh sách
            </Link>
          </Button>
        </div>
      </div>
      <PrescriptionTemplateForm mode="create" />
    </div>
  );
}
